import BranchFundingSourceBaseController from '../common/branch_funding_source.base.controller'
import AppConstants from '../../../config/app.constants';

class BranchFundingSourceEditController extends BranchFundingSourceBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, BranchFundingSourceService, Modal, $translate, LocationService, $stateParams, ShiptypeService, UserBranchService,
				BranchService, $q, $scope, TimezoneList, UsersService, DateUtil, BranchFundingSourceOrderProfileService, CommonLayoutService, CurrencyService) {
		super(Auth, $state, User, BranchFundingSourceService, Modal, $translate, $scope)

		this.LocationService = LocationService;
		this.ShiptypeService = ShiptypeService;
		this.BranchService = BranchService;
		this.$stateParams = $stateParams;
		this.UserBranchService = UserBranchService;
		this.TimezoneList = TimezoneList;
		this.UsersService = UsersService;
		this.DateUtil = DateUtil;
		this.BranchFundingSourceOrderProfileService = BranchFundingSourceOrderProfileService;
		this.CommonLayoutService = CommonLayoutService;
		this.CurrencyService = CurrencyService;
		this.$q = $q;
		this.hasACL = {};
		this.rawId = '';
		this.emailValidation = true;

		this.defaultModel = {
			// id: '',
			sourceName: '',
			branchId: User.getUser().branchId,
			shiptypeId: null,
			locationId: null,
			loggedInUser: User.getUser().id,
			maxResidualDeposit: null,
			residualDeposit: false,
			manualDeposit: false,
			enableBankReport: false,
			bankReportFTPHost: null,
			bankReportFTPPort: 22,
			bankReportFTPUser: null,
			bankReportFTPPassword: null,
			bankReportFTPPrivateKey: null,
			key: "password",
			bankReportFTPDirectory: null,
			bankReportFilenameFormat: null,
			enableVaultReport: false,
			requireCountCommit: false,
			vaultReportRecipientName: null,
			vaultReportRecipientEmail: null,
			unpackAnyTime: false,
			editCountAnytime: false,
			deliveryReport: false,
			enforceBalanceCheckOnVaultClose: false,
			partialECDeposit: false,
			enableOrderMgmt: false,
			orderLeadTime: false,
			orderLeadDay: null,
			customerOrderLeadTime: false,
			orderLeadDays: null,
			orderLeadCutoff: null,
			depositProcessingTime: null,
			enforceStraps: false,
			orderInterest: false,
			loadedInterest: false,
			residualInterest: false,
			autoOrdering: false,
			autoOrderApproval: false,
			orderSequenceStart: 0,
			orderApprovalThreshold: null,
			businessDayMon: false,
			businessDayTue: false,
			businessDayWed: false,
			businessDayThu: false,
			businessDayFri: false,
			businessDaySat: false,
			businessDaySun: false,
			businessDayHol: false,
			orderInterestPercentage: null,
			loadedInterestPercentage: null,
			residualInterestPercentage: null,
			networkData: false,
			autoReconcile: false,
			allowECLoad: false,
			orderCutoffTime: null,
			maxOrders: null,
			orderIdSequencing: false,
			regularInventoryId: null,
			emergencyInventoryId: null,
			editAmount: false,
			allowAmount: false,
			adHocDeposit: false,
			unifiedInventoryId: null,
			bankReportType: 'NONE',
			multiDenomPack: true,
			multiDenomBillLimit: null,
			expectedResidual: false,
			timezone: null,
			pocEmail: '',
			atmForecasting: false,
			currencyId: null,
			ecOrderLeadTime: null,
			varianceCheckEnabled: false,
			varianceThreshold: 0,
			autoCreateShipments: false,
			inventoryBulkCoin: false,
			debitBulkCoinOnPack: false,
			vaultReportFileType: '',
			bagoutForCount: false,
			contractedRate: null,
			averageBalanceFee: false,
			customerACH: false,
			customerACHOrderLeadDays: null,
			customerACHSettlementDays: null,
			bankOrder: false,
			bankOrderLeadDays: null,
			autoSendAccounting: false,
			autoSendAccountingTime: null,
			autoSendAccountingEmails: null,
			autoSendCustomerCount: false,
			autoSendCustomerCountTime: null,
			autoSendCustomerACH: false,
			autoSendCustomerACHTime: null,
		};

		this.businessDays = [{
			label: this.$translate.instant('location.mon'),
			model: 'businessDayMon'
		},
		{
			label: this.$translate.instant('location.tues'),
			model: 'businessDayTue'
		},
		{
			label: this.$translate.instant('location.wed'),
			model: 'businessDayWed'
		},
		{
			label: this.$translate.instant('location.thurs'),
			model: 'businessDayThu'
		},
		{
			label: this.$translate.instant('location.fri'),
			model: 'businessDayFri'
		},
		{
			label: this.$translate.instant('location.sat'),
			model: 'businessDaySat'
		},
		{
			label: this.$translate.instant('location.sun'),
			model: 'businessDaySun'
		},
		{
			label: this.$translate.instant('location.hol'),
			model: 'businessDayHol'
		}
		];

		this.orderLeadDays = [{
			label: this.$translate.instant('branchFundingSource.one_business_day'),
			value: 1
		}, {
			label: this.$translate.instant('branchFundingSource.two_business_day'),
			value: 2
		}, {
			label: this.$translate.instant('branchFundingSource.three_business_day'),
			value: 3
		}, {
			label: this.$translate.instant('branchFundingSource.four_business_day'),
			value: 4
		}, {
			label: this.$translate.instant('branchFundingSource.five_business_day'),
			value: 5
		}];
		this.locationData = [];
		this.shiptypeData = [];
		this.branch = [];
		this.model = angular.copy(this.defaultModel)
		this.loading = false;
		this.timezoneList = this.TimezoneList.getTimezoneList();
		this.browserTimezone = moment.tz.guess();
		this.bankReportTypes = this.CommonLayoutService.bankReportTypes();
		this.vaultReportFileTypes = [
			{ label: 'Excel', value: 'excel' },
			{ label: 'PDF', value: 'pdf' }
		]

		this.intervalList = [
			{
				label: 'Dynamic',
				value: 'dynamic',
				day: 0
			},
			{
				label: 'Weekly',
				value: 'weekly',
				day: 7
			},
			{
				label: 'Bi-Weekly',
				value: 'Bi-weekly',
				day: 10
			},
			{
				label: 'First Day of Month',
				value: 'first-day-of-month',
				day: 30
			},
			{
				label: '2nd Weekly',
				value: '2nd-weekly',
				day: 14
			},
			{
				label: '3rd Weekly',
				value: '3rd-weekly',
				day: 21
			},
			{
				label: '4th Weekly',
				value: '4th-weekly',
				day: 28
			},
			{
				label: '5th Weekly',
				value: '5th-weekly',
				day: 35
			},
			{
				label: '6th Weekly',
				value: '6th-weekly',
				day: 42
			},
			{
				label: '7th Weekly',
				value: '7th-weekly',
				day: 49
			},
			{
				label: '8th Weekly',
				value: '8th-weekly',
				day: 56
			},
			{
				label: '9th Weekly',
				value: '9th-weekly',
				day: 63
			},
			{
				label: '10th Weekly',
				value: '10th-weekly',
				day: 70
			},
			{
				label: '11th Weekly',
				value: '11th-weekly',
				day: 77
			},
			{
				label: '12th Weekly',
				value: '12th-weekly',
				day: 84
			}
		];

		this.orderingProfileOptions = [];
		this.deleteOrderProfileRecord = [];
	}

	$onInit() {
		this.model.loading = true;
		this.$q.all([
			this.UserBranchService.getUserBranches(this.model.loggedInUser),
			this.Service.get(this.$stateParams.id),
			this.UsersService.getUserFieldData(this.model.loggedInUser),
			// this.getOrderProfile(),
			this.getFundingSourceHolidayCount(),
			this.CurrencyService.all(null, 0, 100),
			this.BranchService.getBranchSetup(this.model.branchId)
		])
			.then((data) => {
				this.branch = data[0].results.map((b) => (b.branchId));
				this.branchFundingData = data[1].results;
				this.defaultModel = data[1].results;
				Object.assign(this.model, data[1].results)
				this.model.id = data[1].results.id;
				this.userDetails = data[2];
				this.model.timezone = data[1].results.autoOrdering == false ? data[1].results.timezone = null : data[1].results.timezone;
				this.model.maxResidualDeposit = data[1].results.maxResidualDeposit ? data[1].results.maxResidualDeposit : null;
				this.model.orderInterestPercentage = data[1].results.orderInterestPercentage ? this.ngPercentage('orderInterestPercentage') : null;
				this.model.loadedInterestPercentage = data[1].results.loadedInterestPercentage ? this.ngPercentage('loadedInterestPercentage') : null;
				this.model.residualInterestPercentage = data[1].results.residualInterestPercentage ? this.ngPercentage('residualInterestPercentage') : null;
				this.model.orderCutoffTime = this.DateUtil.getTime(data[1].results.orderCutoffTime);
				this.model.orderLeadCutoff = this.DateUtil.getTime(data[1].results.orderLeadCutoff);
				this.model.autoSendAccountingTime = this.DateUtil.getTime(data[1].results.autoSendAccountingTime);
				this.model.autoSendCustomerCountTime = this.DateUtil.getTime(data[1].results.autoSendCustomerCountTime);
				this.model.autoSendCustomerACHTime = this.DateUtil.getTime(data[1].results.autoSendCustomerACHTime);
				this.model.key = this.model.bankReportFTPPassword ? 'password' : this.model.bankReportFTPPrivateKey ? 'privateKey' : null;
				this.model.contractedRate =  data[1].results.averageBalanceFee ? data[1].results.contractedRate : null;
				this.model.averageBalanceFee = data[1].results.averageBalanceFee;
				if (data[1].results.location) {
					data[1].results.location.Key = data[1].results.location.id + " | " + data[1].results.location.name;
					data[1].results.location.Value = data[1].results.location.id;
				}
				if (data[1].results.shiptype) {
					data[1].results.shiptype.Key = data[1].results.shiptype.id + " | " + data[1].results.shiptype.description;
					data[1].results.shiptype.Value = data[1].results.shiptype.id;
				}
				if (data[1].results.currency) {
					data[1].results.currency.Key = data[1].results.currency.id + " | " + data[1].results.currency.name;
					data[1].results.currency.Value = data[1].results.currency.id;
				}
				this.model.locationId = data[1].results.location;
				this.model.shiptypeId = data[1].results.shiptype;
				this.branchFundingSourceDenominations = _.cloneDeep(this.branchFundingData.denominations);
				this.model.denominations = data[1].results.denominations;
				_.flatten(_.values(this.model.denominations)).forEach(d => this.addResidualPercentSign(d));
				this.branchSetup = data[5];
				this.currencyData = data[4].results.filter((o)=> this.branchSetup.availableCurrencyIds && this.branchSetup.availableCurrencyIds.includes(o.id));
				this.defaultModel.currencyId = this.branchSetup.availableCurrencyIds ? this.branchSetup.availableCurrencyIds.find((c) => c === this.defaultModel.currencyId) || this.defaultModel.currencyId : this.defaultModel.currencyId;
				this.model.currencyId = this.defaultModel.currencyId;
				this.originalCurrencyId = this.defaultModel.currencyId;
				this.getAllLocation('', 0);
				this.getAllShiptype('', 0);
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.model.loading = false;
			});
	}

	// get all location
	getAllLocation(searchKey, offset) {
		searchKey = searchKey || null;
		const locationId = this.model.locationId ? this.model.locationId.Value : null;

		if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
			offset = offset - 1;
		}

		this.Service.fundingSourceLocation(locationId, searchKey, this.model.branchId, AppConstants.defaultPageLimit, offset)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.totalRecord = data.total;
					this.locationList = this.mappingLocationData(data.results, searchKey);
					if (!searchKey && this.model.locationId) {
						this.locationList.unshift(this.model.locationId);
					}
				}
				else {
					const location = this.mappingLocationData(data.results, searchKey);
					this.locationList = this.locationList.concat(location);
				}
			})
			.catch((err) => {
				this.errorMessage = err.data.message + '<br/>';
			})
	}

	mappingLocationData(locations, searchKey) {
		let location = [];
		locations.map((loc) => {
			loc.Key = loc.locationId + " | " + loc.locationName;
			loc.Value = loc.locationId;
			if (!searchKey && this.model.locationId) {
				if (loc.locationId !== this.model.locationId.id) {
					location.push(loc);
				}
			} else {
				location.push(loc);
			}
		});
		return location;
	}

	// load all shiptype
	loadshiptype(searchKey, offset) {

		searchKey = searchKey || '';

		const shiptypeSearchObj = {
			queryJSON: {
				rules: [
					{
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							},
							{
								field: 'description',
								condition: 'like',
								data: '%' + searchKey + '%'
							}
							],
							operator: 'OR'
						}
					}
				],
				operator: 'AND'
			},
		}

		return shiptypeSearchObj.queryJSON.rules.length ? shiptypeSearchObj : null;
	}

	// get all shiptype
	getAllShiptype(searchKey, offset) {
		const loadShiptypeDatas = this.loadshiptype(searchKey);
		if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
			offset = offset - 1;
		}
		this.ShiptypeService.all(loadShiptypeDatas, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.totalRecords = data.total;
					this.shiptypeList = this.mappingShiptypeData(data.results, searchKey);
					if (!searchKey && this.model.shiptypeId) {
						this.shiptypeList.unshift(this.model.shiptypeId);
					}
				}
				else {
					const shiptype = this.mappingShiptypeData(data.results, searchKey);
					this.shiptypeList = this.shiptypeList.concat(shiptype);
				}
			})
	}

	mappingShiptypeData(shiptypes, searchKey) {
		let shiptypeData = [];
		shiptypes.map((shiptype) => {
			if (!searchKey) {
				if (shiptype.id !== this.model.shiptypeId.id) {
					shiptype.Key = shiptype.id + " | " + shiptype.description;
					shiptype.Value = shiptype.id;
					shiptypeData.push(shiptype);
				}
			} else {
				shiptype.Key = shiptype.id + " | " + shiptype.description;
				shiptype.Value = shiptype.id;
				shiptypeData.push(shiptype);
			}
		});
		return shiptypeData;
	}

	reset() {
		this.isLoading = true;
		this.model.loading = true;
		this.Service.get(this.$stateParams.id)
			.then((data) => {
				this.branchFundingData = data.results;
				this.defaultModel = data.results;
				const loggedInUser = this.model.loggedInUser;
				this.model = angular.copy(this.defaultModel);
				this.model.loggedInUser = loggedInUser;
				this.model.orderCutoffTime = this.DateUtil.getTime(this.model.orderCutoffTime);
				this.model.orderLeadCutoff = this.DateUtil.getTime(this.model.orderLeadCutoff);
				this.model.autoSendAccountingTime = this.DateUtil.getTime(this.model.autoSendAccountingTime);
				this.model.autoSendCustomerCountTime = this.DateUtil.getTime(this.model.autoSendCustomerCountTime);
				this.model.autoSendCustomerACHTime = this.DateUtil.getTime(this.model.autoSendCustomerACHTime);
				this.model.timezone = this.defaultModel.timezone;

				if (this.branchFundingData.location) {
					this.branchFundingData.location.Key = this.branchFundingData.location.id + " | " + this.branchFundingData.location.name;
					this.branchFundingData.location.Value = this.branchFundingData.location.id;
				}
				if (this.branchFundingData.shiptype) {
					this.branchFundingData.shiptype.Key = this.branchFundingData.shiptype.id + " | " + this.branchFundingData.shiptype.description;
					this.branchFundingData.shiptype.Value = this.branchFundingData.shiptype.id;
				}
				this.model.locationId = this.branchFundingData.location;
				this.model.shiptypeId = this.branchFundingData.shiptype;

				this.deleteOrderProfileRecord = [];
				this.orderProfileData = [];
				this.orderingProfileOptions = [];
				this.getAllLocation('', 0);
				this.clearErrors();
				this.model.key = this.model.bankReportFTPPassword ? 'password' : this.model.bankReportFTPPrivateKey ? 'privateKey' : null;
				this.model.denominations = this.branchFundingData.denominations;
				_.flatten(_.values(this.model.denominations)).forEach(d => this.addResidualPercentSign(d));
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.isLoading = false;
				this.model.loading = false;
			})
	}

	loadBranchLocations() {
		this.model.locationId = null;
		this.getAllLocation('', 0);
	}

	submit() {
		this.generateOrderProfile();
		this.loading = true;

		let updateObj = {
			id: this.model.id,
			sourceName: this.model.sourceName,
			branchId: this.model.branchId,
			shiptypeId: this.model.shiptypeId.Value,
			locationId: this.model.locationId.Value,
			maxResidualDeposit: this.model.maxResidualDeposit ? this.model.maxResidualDeposit : null,
			orderInterestPercentage: this.model.orderInterestPercentage ? this.removePrecentageSign('orderInterestPercentage') : null,
			loadedInterestPercentage: this.model.loadedInterestPercentage ? this.removePrecentageSign('loadedInterestPercentage') : null,
			residualInterestPercentage: this.model.residualInterestPercentage ? this.removePrecentageSign('residualInterestPercentage') : null,
			currencyId: this.model.currencyId,
			varianceCheckEnabled: this.model.varianceCheckEnabled,
			contractedRate: this.model.averageBalanceFee ? this.model.contractedRate : null,
			averageBalanceFee: this.model.averageBalanceFee,
		};

    updateObj.varianceThreshold = this.model.varianceCheckEnabled ? this.model.varianceThreshold : null;
		updateObj = _.pick(Object.assign(this.model, updateObj), Object.keys(this.defaultModel));
		this.businessDays.forEach((day) => { updateObj[day.model] = !!this.model[day.model]; });
		updateObj.orderCutoffTime = updateObj.orderCutoffTime ? moment(updateObj.orderCutoffTime).format('HH:mm:ss') : null;
		updateObj.orderLeadCutoff = updateObj.orderLeadCutoff ? moment(updateObj.orderLeadCutoff).format('HH:mm:ss') : null;
		updateObj.autoSendAccountingTime = updateObj.autoSendAccountingTime ? moment(updateObj.autoSendAccountingTime).format('HH:mm:ss') : null;
		updateObj.autoSendCustomerCountTime = updateObj.autoSendCustomerCountTime ? moment(updateObj.autoSendCustomerCountTime).format('HH:mm:ss') : null;
		updateObj.autoSendCustomerACHTime = updateObj.autoSendCustomerACHTime ? moment(updateObj.autoSendCustomerACHTime).format('HH:mm:ss') : null;
		updateObj.orderLeadDays = this.model.customerOrderLeadTime && this.model.orderLeadDays !== null && this.model.orderLeadDays !== ''
			? parseInt(this.model.orderLeadDays, 10)
			: null;
		updateObj.customerACHOrderLeadDays = this.model.customerACH && this.model.customerACHOrderLeadDays !== null && this.model.customerACHOrderLeadDays !== ''
			? parseInt(this.model.customerACHOrderLeadDays, 10)
			: null;
		updateObj.customerACHSettlementDays = this.model.customerACH && this.model.customerACHSettlementDays !== null && this.model.customerACHSettlementDays !== ''
			? parseInt(this.model.customerACHSettlementDays, 10)
			: null;
		updateObj.bankOrderLeadDays = this.model.bankOrder && this.model.bankOrderLeadDays !== null && this.model.bankOrderLeadDays !== ''
			? parseInt(this.model.bankOrderLeadDays, 10)
			: null;
		updateObj.orderProfileData = this.orderProfileData;
		updateObj.userId = this.model.loggedInUser;
		updateObj.deleteOrderProfileRecord = this.deleteOrderProfileRecord;
		updateObj.bankReportFTPPassword = this.model.key === 'password' && this.model.bankReportFTPPassword ? this.model.bankReportFTPPassword : null;
		updateObj.bankReportFTPPrivateKey = this.model.key === 'privateKey' && this.model.bankReportFTPPrivateKey ? this.model.bankReportFTPPrivateKey : null;
		updateObj.unifiedInventoryId = this.model.bankReportType === 'CASHCONNECT' && this.model.unifiedInventoryId ? this.model.unifiedInventoryId : null;
		updateObj.regularInventoryId = this.model.bankReportType === 'USBANK' && this.model.regularInventoryId ? this.model.regularInventoryId : null;
		updateObj.emergencyInventoryId = this.model.bankReportType === 'USBANK' && this.model.emergencyInventoryId ? this.model.emergencyInventoryId : null;
		updateObj.multiDenomBillLimit = this.model.multiDenomPack ? this.model.multiDenomBillLimit : null;
    updateObj.timezone = this.model.timezone ? this.model.timezone : null;
    updateObj.inventoryBulkCoin = this.model.inventoryBulkCoin ? this.model.inventoryBulkCoin : false;
    updateObj.debitBulkCoinOnPack = this.model.debitBulkCoinOnPack ? this.model.debitBulkCoinOnPack : false;
    updateObj.allowAmount = this.model.allowAmount ? this.model.allowAmount : false;
    updateObj.adHocDeposit = this.model.adHocDeposit ? this.model.adHocDeposit : false;
		updateObj.denominations = this.compareObjects(this.branchFundingSourceDenominations, this.model.denominations);

		// delete updateObj.location;
		// delete updateObj.shiptype;
		delete updateObj.currency;

		this.Service.update(this.model.id, {...updateObj, userId : this.model.loggedInUser })
			.then((data) => {
				window.history.go(-1);
			})
			.catch((err) => {

				this.model.shiptypeId = {
					Key: updateObj.shiptype.id + " | " + updateObj.shiptype.description,
					Value: updateObj.shiptype.id
				}

				this.model.locationId = {
					Key: updateObj.location.id + " | " + updateObj.location.name,
					Value: updateObj.location.id
				}

				if (err && err.data && err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
				else {
					this.Modal.errorModal(err.data.message);
				}
			})
			.finally(()=>{
				this.loading = false;
			})
	}

	validateManualDeposit() {
		this.model.manualDeposit = !this.model.residualDeposit;
	}

	validateResidualDeposit() {
		this.model.residualDeposit = !this.model.manualDeposit;
	}

	resetDeposit() {
		if (this.model.manualDeposit) this.model.maxResidualDeposit = null;
	}

	resetBankReportData() {
		if (!this.model.enableBankReport) {
			this.model.bankReportFTPHost = null;
			this.model.bankReportFTPPort = 22;
			this.model.bankReportFTPUser = null;
			this.model.bankReportFTPPassword = null;
			this.model.bankReportFTPPrivateKey = null;
			this.model.bankReportFTPDirectory = null;
			this.model.bankReportFilenameFormat = null;
			this.model.regularInventoryId = null;
			this.model.emergencyInventoryId = null;
			this.model.unifiedInventoryId = null;
			this.model.bankReportType = 'NONE';
		}
		if (!this.model.enableVaultReport) {
			this.model.vaultReportRecipientName = null;
			this.model.vaultReportRecipientEmail = null;
			this.model.key = 'password';
		}
	}

	hasValidEmails(receiverMail) {
		if (!receiverMail) return false;
		const emails = receiverMail.split(',').map(email => email.trim());
	  
		const uniqueEmails = new Set();
		for (const email of emails) {
		  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
			return false; 
		  }
		  if (uniqueEmails.has(email)) {
			return false; 
		  }
		  uniqueEmails.add(email);
		}
	  
		return true;
	  };

	isDaySelected(day) {
		return this.model[day.model];
	}

	toggleDay(day) {
		this.model[day.model] = !this.model[day.model]
	}

	resetOrderMgmt() {
		if (!this.model.enableOrderMgmt) {

		};
	}

	resetAutoOrderingData() {
		if (!this.model.autoOrdering) {
			this.model.networkData = false;
			this.model.autoReconcile = false;
			this.model.allowECLoad = false;
			this.model.enforceStraps = false;
			this.model.orderLeadTime = false;
			this.model.orderLeadDay = null;
			this.model.depositProcessingTime = null;
			this.model.enforceStraps = false;
			this.model.orderInterest = false;
			this.model.loadedInterest = false;
			this.model.residualInterest = false;
			this.model.orderInterestPercentage = null;
			this.model.loadedInterestPercentage = null;
			this.model.residualInterestPercentage = null;
			this.model.orderCutoffTime = null;
			this.model.timezone = null;
			this.model.maxOrders = null;
			this.model.orderIdSequencing = false;
			this.model.autoOrderApproval = false;
			this.model.orderSequenceStart = null;
			this.model.orderApprovalThreshold = null;
			this.orderingProfileOptions.forEach((obj) => {
				this.deleteOrderProfileRecord.push(obj.orderProfileId);
			})
			this.orderProfileData = [];
			this.orderingProfileOptions = [];
			this.model.ecOrderLeadTime = null;
		}
	}

	resetCustomerOrderLeadData() {
		if (!this.model.customerOrderLeadTime) {
			this.model.orderLeadDays = null;
			this.model.orderLeadCutoff = null;
		}
	}

	resetCustomerAchData() {
		if (!this.model.customerACH) {
			this.model.customerACHOrderLeadDays = null;
			this.model.customerACHSettlementDays = null;
		}
	}

	resetBankOrderData() {
		if (!this.model.bankOrder) {
			this.model.bankOrderLeadDays = null;
		}
	}

	resetAchSendAccountingData() {
		if (!this.model.autoSendAccounting) {
			this.model.autoSendAccountingTime = null;
			this.model.autoSendAccountingEmails = null;
		}
	}

	resetAutoSendCustCountData() {
		if (!this.model.autoSendCustomerCount) {
			this.model.autoSendCustomerCountTime = null;
		}
	}

	resetAutoSendCustACHData() {
		if (!this.model.autoSendCustomerACH) {
			this.model.autoSendCustomerACHTime = null;
		}
	}

	ngPercentage(key) {
		if (this.model[key]) {
			let str = this.model[key].toString();
			return this.model[key] = str ? str.endsWith('%') ? str : str + '%' : null;
		}
	}

	removePrecentageSign(key) {
		if (this.model[key] && this.model[key].length) {
			let str = this.model[key] || '';
			return this.model[key] = str.endsWith('%') ? str.replace('%', '') : str;
		}
	}

	// addOrderProfile() {
	// 	this.orderingProfileOptions.push({
	// 		profileName: null,
	// 		addsOrSwaps: 0,
	// 		maxLoadDays: 7,
	// 		isEdit: true,
	// 		isValidProfile: false,
	// 		status: true,
	// 		intervalObj: {
	// 			interval: {
	// 				label: 'Weekly',
	// 				value: 'weekly',
	// 				day: 7
	// 			},
	// 			intervalOptions: this.intervalList
	// 		},
	// 		orderProfileId: null
	// 	})
	// }

	validateOrderingProfileFormControl() {
		var disableButton = this.orderingProfileOptions.map((data) => {
			this.isValidFormControl = true;
			this.isValidFormControl = this.isValidFormControl && data.isValidProfile;
			return this.isValidFormControl;
		})
		if (disableButton.indexOf(false) >= 0 && this.orderingProfileOptions.length > 0) return false;
		else return true;
	}

	removeOrderingProfile(obj, index) {
		this.Modal.confirm({
			header: this.$translate.instant('common.confirm_delete_title'),
			message: this.$translate.instant('common.confirm_delete_message') + '?',
			callback: (({
				modal,
				$scope
			}) => {
				this.orderingProfileOptions.splice(index, 1);
				if (obj.orderProfileId) this.deleteOrderProfileRecord.push(obj.orderProfileId);
				modal.close();
			}),
			negative: (({
				modal,
			}) => {
				modal.close();
			}),
			type: 'danger'
		})
	}

	saveOrderingProfile(obj, event) {
		event.preventDefault();
		obj.isValidProfile = true;
	}

	setEditFlag(obj) {
		obj.isEdit = false;
	}

	editOrderingProfile(obj) {
		obj.isEdit = true;
		obj.isValidBillingRules = false;
	}

	setMTBWLValue(obj) {
		const selectedInterval = obj.intervalObj.interval;
		obj.maxLoadDays = selectedInterval['day'];
	}

	generateOrderProfile() {
		if (!this.orderingProfileOptions.length) return [];
		this.orderProfileData = [];

		this.orderingProfileOptions.forEach((obj) => {
			this.orderProfileData.push({
				profileName: obj.profileName,
				addsOrSwaps: obj.addsOrSwaps,
				maxLoadDays: obj.maxLoadDays,
				status: obj.status,
				intervalLabel: obj.intervalObj.interval.label,
				intervalValue: obj.intervalObj.interval.value,
				orderProfileId: obj.orderProfileId ? obj.orderProfileId : null
			})
		})
	}

	orderProfileQuery() {
		const orderProfileObj = {
			queryJSON: {
				rules: [{
					field: 'branchFundingSourceId',
					condition: '=',
					data: this.$stateParams.id
				}],
				operator: 'AND'
			},
		}

		return orderProfileObj.queryJSON.rules.length ? orderProfileObj : null;
	}

	getOrderProfile() {
		const searchObj = this.orderProfileQuery();

		this.BranchFundingSourceOrderProfileService.all(searchObj, 0, 100)
			.then((orderProfile) => {
				orderProfile.results.forEach((op, index) => {
					const loadInterval = op.loadInterval ? _.find(this.intervalList, { 'value': op.loadInterval }) : null;

					this.orderingProfileOptions.push({
						name: op.name,
						description: op.description,
						status: op.status,
						isValidBillingRules: true,
						intervalObj: {
							interval: loadInterval,
							intervalOptions: this.intervalList
						},
						isEdit: false,
						profileName: op.name,
						addsOrSwaps: op.addsBWSwaps,
						maxLoadDays: op.maxBWLoads,
						isValidProfile: true,
						status: op.active,
						orderProfileId: op.id
					})
				})
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.loading = false;
			})
	}

	updateOrderProfileStatus(obj) {
		this.Modal.confirmSupervisor('update-order-profile-status', null, ({ modal, supId }) => {
			obj.status = !obj.status;
			modal.close();
		}, ({ modal }) => {
			modal.close();
			this.isLoading = false;
		});
	}

	getFundingSourceHolidayCount() {
		const startDate = moment().format('YYYY-MM-DD');
		const endDate = moment().endOf('year').format('YYYY-MM-DD');

		this.Service.getFundingSourceHolidayCount(this.$stateParams.id, startDate, endDate)
			.then((data) => {
				this.totalFundingSourceHoliday = data.total;
			})
			.catch((err) => {
				console.log(err);
			})
	}
	// convertDateTime() {
	// 	const orderCutoffTime = moment.tz(this.model.orderCutoffTime, this.model.timezone).format('HH:mm:ss');
	// 	this.model.orderCutoffTime = this.DateUtil.getTime(orderCutoffTime);
	// 	console.log(this.model.orderCutoffTime)
	// }

	branchFundingSourceDenominationsModal() {
		this.Modal.branchFundingSourceDenominations(this.model.denominations, ({ modal, denominations, deletedDenominations, $scope }) => {
			this.isLoading = true;
			setTimeout(() => {
				this.model.denominations = denominations;
				// Store deleted denominations for tracking
				this.deletedDenominations = deletedDenominations || [];
				this.isLoading = false;
			}, 100);
			modal.close();
		}, ({ modal }) => {
			modal.close();
		}, this.model.currencyId);
	}

	isMultiDenomAllowed(denom) {
		if (!denom.coinFlag) {
			return true;
		}
		if (denom.coinPackaging && ['INDIVIDUAL','ROLLED'].includes(denom.coinPackaging)) {
			return true;
		}
		return false;
	}

	toggleMultiDenom(obj) {
		if (this.isMultiDenomAllowed(obj)) {
			obj.multiDenomAllowed = !obj.multiDenomAllowed;
		}
	}

	isExpectedResidualDenom(denom) {
		return !denom.coinFlag && !denom.unfit;
	}

	expectedResidualValue(denom) {
		if (!this.model.expectedResidual || !this.isExpectedResidualDenom(denom)) return null;
		const value = denom.expectedResidualPercentage;
		if (value === null || value === undefined || value === '') return null;
		return Number(String(value).replace('%', ''));
	}

	addResidualPercentSign(denom) {
		const value = denom.expectedResidualPercentage;
		if (value !== null && value !== undefined && String(value) !== '' && !String(value).endsWith('%')) {
			denom.expectedResidualPercentage = value + '%';
		}
	}

	removeResidualPercentSign(denom) {
		const value = denom.expectedResidualPercentage;
		if (value && String(value).endsWith('%')) {
			denom.expectedResidualPercentage = String(value).replace('%', '');
		}
	}

	toggleCustomerOrderable(obj) {
		obj.customerOrderable = !obj.customerOrderable;
	}

	validateMultiDenom(obj) {
		setTimeout(() => {
			if (!obj.isDenomSelected) {
				obj.multiDenomAllowed = false;
			} else {
				if (!this.isMultiDenomAllowed(obj)) {
					obj.multiDenomAllowed = false;
				}
			}
			this.$scope.$apply();
		});
	}

	removeDenomination(key, index) {
		this.model.denominations[key].splice(index, 1);
	}

	onCurrencyChange() {
		if (this.originalCurrencyId) {
			if (this.model.currencyId === this.originalCurrencyId) {
				if (this.branchFundingSourceDenominations && Object.keys(this.branchFundingSourceDenominations).length > 0) {
					this.model.denominations = _.cloneDeep(this.branchFundingSourceDenominations);
					_.flatten(_.values(this.model.denominations)).forEach(d => this.addResidualPercentSign(d));
				}
			} else {
				if (this.model.denominations && Object.keys(this.model.denominations).length > 0) {
					this.model.denominations = {};
				}
			}
		}
	}

	compareObjects(objA, objB) {
		const results = { create: [], update: [], delete: [] };

		// First, add all deleted denominations from modal tracking
		if (this.deletedDenominations && this.deletedDenominations.length > 0) {
			results.delete = results.delete.concat(this.deletedDenominations);
		}

		const idSetA = {};

		for (const category in objA) {
			objA[category].forEach(itemA => {
				idSetA[itemA.id] = itemA;
			});
		}

		for (const category in objA) {
			objA[category].forEach(itemA => {
				const itemB = objB[category] ? objB[category].find(item => item.id === itemA.id) : null;
				if (itemB) {
					const pctA = itemA.expectedResidualPercentage === null || itemA.expectedResidualPercentage === undefined ? null : Number(itemA.expectedResidualPercentage);
					const pctB = this.expectedResidualValue(itemB);
					if (itemA.multiDenomAllowed !== itemB.multiDenomAllowed || itemA.customerOrderable !== itemB.customerOrderable || pctA !== pctB) {
						results.update.push({
							denominationId: itemB.id,
							multiDenomAllowed: itemB.multiDenomAllowed || false,
							customerOrderable: itemB.customerOrderable || false,
							expectedResidualPercentage: pctB,
							currencyId: itemB.currencyId,
							coinFlag: itemB.coinFlag,
							id: itemA.branchFundingSourceDenominationId,
							modifiedByUserId: this.model.loggedInUser
						});
					}
				} else {
					// Only add to delete if not already tracked by modal
					const alreadyTracked = this.deletedDenominations && 
						this.deletedDenominations.find(d => d.denominationId === itemA.id);
					if (!alreadyTracked) {
						results.delete.push({
							id: itemA.branchFundingSourceDenominationId,
							multiDenomAllowed: itemA.multiDenomAllowed || false,
							currencyId: itemA.currencyId,
							coinFlag: itemA.coinFlag,
							denominationId: itemA.id,
						});
					}
				}
			});
		}

		for (const category in objB) {
			// if (!objA[category]) continue;

			objB[category].forEach(itemB => {
				if (!idSetA[itemB.id]) {
					results.create.push({
						createdByUserId: this.model.loggedInUser,
						modifiedByUserId: this.model.loggedInUser,
						denominationId: itemB.id,
						multiDenomAllowed: itemB.multiDenomAllowed || false,
						customerOrderable: itemB.customerOrderable || false,
						expectedResidualPercentage: this.expectedResidualValue(itemB),
						branchFundingSourceId: this.model.id,
						currencyId: itemB.currencyId,
						coinFlag: itemB.coinFlag,
					});
				}
			});
		}

		return results;
	}

}

export default BranchFundingSourceEditController;



// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/edit/branch_funding_source.edit.controller.js